module.exports = __webpack_public_path__ + "img/logo-co2.c3e7e4d9.png";